module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_0.c6af13ba.png";